let DinamicTestInputs = require('@/mixins/Forms/DinamicTestInputs')

module.exports = {

    mixins: [DinamicTestInputs],

    props: {
        data: {
            required: true,
        },
        testId:{
            type: Number,
            required: false,
            default: null,
        },
        url: {
            type: String,
            required: true,
            type: String,
        },
        space: {
            type: [Object, null],
            required: false,
            default: null
        },
        returnUrl :{
            required: true,
            type: String,
        }
    },

    data() {
        return {
            interval: null,
            form: new Form({
                comments: this.data ? this.data.comments : '',
                testResult: this.data ? this.data.testResult : false,
            }, false)
        }
    },

    mounted() {
        if (this.data != null) {
            this.form = new Form(this.data).dontClear();
        }
        this.interval = setInterval(this.initTest, 250);

        // Prevent people to press Enter.
        $(document).keypress(event => {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                event.preventDefault();
            }
        });
    },

    methods: {

        initTest() {
            // Called from Components.
        },

        save() {
            this.form.patch(this.url).then(response => {
                this.redirectTo(this.returnUrl);
            }).catch(errors => {
                Alert.error(errors.first())
            })
        },

        isValidNumber(number) {
            if (number === "") return false;
            return (!isNaN(number) && number != 'Infinity')
        },

        testResult(result) {
            return result ? '<span class="complies">Complies</span>' : '<span class="no-complies">Does Not Comply</span>';
        },
    },

    computed: {

        isSubmitted() {
            return this.form.isSubmitted;
        },

        testIsReady(){
            return (this.form.functional_test != undefined && this.form.construction_inspection != undefined);
        },

        isParking() {
            return this.space ? (this.space.type == 'parking') : false;
        }
    },

    destroy() {
        this.interval.clear();
    }
}
